import axios from 'axios'
import { useCallback } from 'react'

import type { PROPERTY_TYPES } from '../../common/drmTypes'
import { PropertyDataTypes } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'
import type { PriceData } from '../../redux/propertyPriceSlice'
import { requestPropertyPricePath } from './paths'
import { useDispatchFetch } from './useDispatchFetch'

interface FetchPriceArgs {
  propertyId?: string
  propertyType?: PROPERTY_TYPES
}

export const useFetchPropertyPrice = () => {
  const token = useAppSelector(state => state.myProfile.token)
  const { dispatchError, dispatchFetching, dispatchSuccess } =
    useDispatchFetch()

  const fetchPropertyPrice = useCallback(
    async ({ propertyId, propertyType }: FetchPriceArgs) => {
      if (!token || !propertyId || !propertyType) {
        return dispatchError(PropertyDataTypes.PRICE)
      }

      dispatchFetching(PropertyDataTypes.PRICE)

      try {
        const url = requestPropertyPricePath(propertyType, token, propertyId)
        const response = await axios.get(url)
        const payload = response.data as PriceData
        dispatchSuccess(PropertyDataTypes.PRICE, payload)
        return payload
      } catch (error) {
        dispatchError(PropertyDataTypes.PRICE)
        return null
      }
    },
    [dispatchError, dispatchFetching, dispatchSuccess, token]
  )

  return fetchPropertyPrice
}
